function maskSsn(last4: string | null | undefined): string {
  if (!last4) return "";
  return `\u2022\u2022\u2022-\u2022\u2022-${last4}`;
}

function formatPlaidAddress(
  address: {
    street: string | null;
    street2: string | null;
    city: string | null;
    region: string | null;
    postal_code: string | null;
  } | null
): string {
  if (!address) return "";
  const line1 = [address.street, address.street2].filter(Boolean).join(" ");
  const line2 = [address.city, address.region].filter(Boolean).join(", ");
  const line2WithZip = [line2, address.postal_code].filter(Boolean).join(" ");
  return [line1, line2WithZip].filter(Boolean).join("\n");
}

export { maskSsn, formatPlaidAddress };
